module.exports = __webpack_public_path__ + "img/96f727012e0b41638351b9b71715ce66.a3b64b32.png";